import { render, staticRenderFns } from "./Orderable.vue?vue&type=template&id=9524eb96"
import script from "./Orderable.vue?vue&type=script&lang=js"
export * from "./Orderable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports